/**
 * Snapshot del carrito al tocar Cobrar desde Mesas (preview).
 * Si el mozo saca ítems antes de cobrar, al cerrar la venta vuelven a Pendiente.
 *
 * Tipo opaco: no importar CartItem desde pos (boundary hospitality ↛ pos/store).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type BaselineCartItem = Record<string, any>;

let baselineCart: BaselineCartItem[] = [];

export function setTablesideCheckoutBaseline(items: BaselineCartItem[]): void {
  baselineCart = items.map((item) => ({ ...item }));
}

export function takeTablesideCheckoutBaseline(): BaselineCartItem[] {
  const next = baselineCart;
  baselineCart = [];
  return next;
}

export function clearTablesideCheckoutBaseline(): void {
  baselineCart = [];
}
